(() => {
  'use strict';
  const card = document.getElementById('UraWelcome');
  if (!card) return;
  const key = 'ura-welcome-v1';
  const narrow = matchMedia('(max-width: 600px)');
  const body = card.querySelector('.ura-welcome__body');
  const expand = card.querySelector('[data-welcome-expand]');
  const success = card.querySelector('[data-welcome-success]');
  let returnFocus = null;
  let dismissed = false;
  let pending = null;
  let retryTimer = 0;
  let attempts = 0;
  let privacyClearAt = 0;
  const read = () => { try { return Number(localStorage.getItem(key)) || 0; } catch (_) { return 0; } };
  const remember = days => { try { localStorage.setItem(key, String(Date.now() + days * 86400000)); } catch (_) {} };
  const visible = element => {
    if (!element || !element.isConnected) return false;
    for (let node = element; node; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (node.hidden || node.getAttribute('aria-hidden') === 'true' || style.display === 'none' || style.visibility === 'hidden') return false;
    }
    const box = element.getBoundingClientRect();
    return box.width > 0 && box.height > 0;
  };
  // Observe presentation only. Shopify remains the sole owner of consent choices and storage.
  const privacyVisible = () => Array.from(document.querySelectorAll('#shopify-pc__banner,#shopify-pc__prefs__dialog')).some(visible);
  const busy = () => document.hidden || Array.from(document.querySelectorAll('dialog[open],[aria-modal="true"]:not([hidden]),[data-cart-drawer][open]')).some(visible) || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '') || document.body.style.overflow === 'hidden';
  const unfold = () => { card.classList.remove('is-compact'); body.hidden = false; expand.setAttribute('aria-expanded', 'true'); };
  const show = manual => {
    card.hidden = false;
    card.classList.toggle('is-compact', narrow.matches && !manual);
    body.hidden = narrow.matches && !manual;
    expand.setAttribute('aria-expanded', String(!body.hidden));
    if (manual) card.querySelector('[data-welcome-close]').focus({ preventScroll: true });
    remember(success ? 3650 : 7);
  };
  const schedule = (delay = 5000) => {
    clearTimeout(retryTimer);
    retryTimer = setTimeout(flush, delay);
  };
  const flush = () => {
    retryTimer = 0;
    if (!pending || privacyVisible()) return;
    if (Date.now() < privacyClearAt) { schedule(privacyClearAt - Date.now()); return; }
    if (pending === 'auto' && (dismissed || read() > Date.now())) { pending = null; return; }
    if (busy()) { if (++attempts < 12) schedule(); else pending = null; return; }
    const mode = pending;
    pending = null;
    if (mode === 'resume') card.hidden = false;
    else show(mode === 'manual');
  };
  const open = manual => {
    if (manual) { returnFocus = document.activeElement; dismissed = false; }
    if (privacyVisible() || Date.now() < privacyClearAt) {
      pending = manual ? 'manual' : 'auto';
      attempts = 0;
      if (!privacyVisible()) schedule(privacyClearAt - Date.now());
      return;
    }
    pending = null;
    clearTimeout(retryTimer);
    show(manual);
  };
  const close = () => {
    const hadFocus = card.contains(document.activeElement);
    card.hidden = true;
    pending = null;
    clearTimeout(retryTimer);
    dismissed = true;
    remember(14);
    if (hadFocus && returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
  };
  let privacyWasVisible = privacyVisible();
  const syncPrivacy = () => {
    const blocked = privacyVisible();
    if (blocked) {
      clearTimeout(retryTimer);
      retryTimer = 0;
      if (!card.hidden) { card.hidden = true; pending = 'resume'; attempts = 0; }
    } else if (privacyWasVisible) {
      privacyClearAt = Date.now() + 5000;
      if (pending) schedule();
    }
    privacyWasVisible = blocked;
  };
  new MutationObserver(syncPrivacy).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden', 'open'] });
  card.querySelector('[data-welcome-close]').addEventListener('click', close);
  expand.addEventListener('click', () => { unfold(); card.querySelector('[data-welcome-shop]')?.focus({ preventScroll: true }); });
  document.querySelectorAll('[data-ura-welcome-open]').forEach(button => button.addEventListener('click', () => open(true)));
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !card.hidden && !privacyVisible()) close(); });
  const formResult = card.querySelector('[data-welcome-success],[data-welcome-error]');
  if (formResult) card.querySelector('.ura-welcome__newsletter').open = true;
  if (formResult && location.hash === '#UraWelcomeForm') { open(true); if (success) remember(3650); return; }
  // Server-confirmed newsletter success also suppresses future invitations after footer signup.
  if (success) { remember(3650); return; }
  if (matchMedia('(max-width: 760px)').matches || card.dataset.auto !== 'true' || read() > Date.now()) return;
  const invite = () => {
    if (dismissed || pending === 'manual' || read() > Date.now()) return;
    pending = 'auto';
    flush();
  };
  setTimeout(invite, 9000);
})();
